module.exports = __webpack_public_path__ + "static/media/200009_kaders.c0a267b8.jpg";